import { useCallback } from 'react';

import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PackageCategory, PackageCategoryWrite } from 'types';
import { client } from 'utils/api-client';

export default function useCreatePackageCategory(): UseMutationResult<
  AxiosResponse<PackageCategory>,
  AxiosError<ErrorMessage>,
  PackageCategoryWrite
> {
  const queryClient = useQueryClient();

  const createPackageCategory = useCallback(
    (packageCategory: PackageCategoryWrite): Promise<AxiosResponse<PackageCategory>> => {
      return client.post('package-categories/', packageCategory);
    },
    [],
  );

  return useMutation(createPackageCategory, {
    onSuccess: () => {
      queryClient.invalidateQueries('packageCategories');
      queryClient.invalidateQueries('packages');
    },
  });
}
